var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcn36(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 3.70116V3.78125H9.375V3.70116C9.92066 3.50753 10.3125 2.98612 10.3125 2.375C10.3125 1.59956 9.68169 0.96875 8.90625 0.96875H3.28125C2.50581 0.96875 1.875 1.59956 1.875 2.375C1.875 2.98612 2.26684 3.5075 2.8125 3.70116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5.1875V4.71875H2.8125V5.1875C2.8125 7.03353 4.30909 8.46875 6.09375 8.46875C7.86678 8.46875 9.375 7.03584 9.375 5.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.6252V14.5627C0 14.8218 0.209656 15.0315 0.46875 15.0315H1.875V12.6877C1.875 12.4286 2.08466 12.219 2.34375 12.219C2.60284 12.219 2.8125 12.4286 2.8125 12.6877V15.0315H7.5V12.9129L3.26472 9.5249C1.39819 9.95971 0 11.6282 0 13.6252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64185 9.13281C4.60901 9.20347 4.55426 9.25963 4.49307 9.30625L6.0937 10.5867L7.69438 9.30619C7.63323 9.25956 7.57845 9.20341 7.54567 9.13281C7.09104 9.30075 6.60601 9.40616 6.09376 9.40616C5.58151 9.40616 5.09648 9.30075 4.64185 9.13281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92277 9.5249L6.84439 11.1877L8.26167 12.3215C8.37292 12.4107 8.43748 12.5453 8.43748 12.6877V15.0315H9.37498V12.6877C9.37498 12.4286 9.58464 12.219 9.84373 12.219C10.1028 12.219 10.3125 12.4286 10.3125 12.6877V15.0315H11.7187C11.9778 15.0315 12.1875 14.8218 12.1875 14.5627V13.6252C12.1875 11.6282 10.7893 9.95978 8.92277 9.5249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 4.71875H11.7812C11.5222 4.71875 11.3125 4.92841 11.3125 5.1875V8.9375C11.3125 9.71294 11.9433 10.3438 12.7188 10.3438H13.1875V14.5625C13.1875 14.8216 13.3972 15.0312 13.6562 15.0312C13.9153 15.0312 14.125 14.8216 14.125 14.5625V10.3438H14.5938C15.3692 10.3438 16 9.71294 16 8.9375V5.1875C16 4.92841 15.7903 4.71875 15.5312 4.71875ZM14.125 8C14.125 8.25909 13.9153 8.46875 13.6562 8.46875C13.3972 8.46875 13.1875 8.25909 13.1875 8V7.0625C13.1875 6.80341 13.3972 6.59375 13.6562 6.59375C13.9153 6.59375 14.125 6.80341 14.125 7.0625V8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcn36);
export default __webpack_public_path__ + "static/media/CCN36.ff802c07af6908fe626d0470d6f405de.svg";
export { ForwardRef as ReactComponent };